Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withStylesPropTypes = exports.withStyles = exports.css = exports.ThemedStyleSheet = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ThemedStyleSheet = require('react-with-styles/lib/ThemedStyleSheet');

var _ThemedStyleSheet2 = _interopRequireDefault(_ThemedStyleSheet);

var _reactWithStyles = require('react-with-styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Note(Maja): while we are in the upgrade process for RWS, we need to make the css prop optional
var withStylesPropTypes = Object.assign({}, _reactWithStyles.withStylesPropTypes, {
  css: _propTypes2['default'].func
});

// eslint-disable-next-line no-restricted-imports
exports.ThemedStyleSheet = _ThemedStyleSheet2['default'];
exports.css = _reactWithStyles.css;
exports.withStyles = _reactWithStyles.withStyles;
exports.withStylesPropTypes = withStylesPropTypes;


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/themes/withStyles.js
// module id = 5
// module chunks = 168707334958949